// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

// # Homepage Card Footer

// ### React
import React from 'react';
import PropTypes from 'prop-types';

const handleClick = (event, href, onClick) => {
  event.preventDefault();
  onClick(event, { href });
};

function HomepageCardFooter(props) {
  return (
    <a
      className={props.className}
      href={props.href}
      onClick={typeof props.onClick === 'function' ? (event) => handleClick(event, props.href, props.onClick) : null}
      target={props.target}
    >
      {props.label}
    </a>
  );
}

// ### Display Name
HomepageCardFooter.displayName = 'HOMEPAGE_CARD_FOOTER';

HomepageCardFooter.defaultProps = {
  href: 'javascript:void(0);', // eslint-disable-line no-script-url
  label: 'View All',
};

HomepageCardFooter.propTypes = {
  /**
   * Class names to be added to the footer link.
   */
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  /**
   * The `href` attribute of the footer. Please pass in bookmarkable URLs from your routing library. If the `onClick` callback is specified this URL will be prevented from changing the browser's location.
   */
  href: PropTypes.string,
  /**
   * The localized text (or component) for the "View All" link.
   */
  label: PropTypes.node,
  /**
   * Function that will be executed when clicking on the footer link
   */
  onClick: PropTypes.func,
  /**
   * Specifies where to display the linked resource (when using href).
   */
  target: PropTypes.string,
};

export default HomepageCardFooter;
